export default function formatValueWithRule(value, rule) {
	if (!rule) {
		return value;
	}
	switch (rule) {
		case "monetary":
			let numericValue = parseFloat(`${value}`.replace(/[^0-9.-]+/g, ""));
			if (!Number.isNaN(numericValue) && !`${numericValue}`.includes(".")) {
				numericValue = `${numericValue}.00`;
			}
			return `$${numericValue}`;
		default:
			return value;
	}
}
